import React from 'react';
import { Bar } from 'react-chartjs-2';
import type { ChartData, ChartOptions } from 'chart.js';
import type { AnalyticsTooltipOption } from '../types';
import { useAnalyticsTooltip } from '../helpers';

interface ChartSeries {
  tooltip: AnalyticsTooltipOption[];
  data: Array<number | { x: number; y: number | null }>;
}

export interface MixedChartsProps {
  areaData: ChartSeries;
  barData: ChartSeries;
}

export const MixedCharts = ({ areaData, barData }: MixedChartsProps) => {
  const tooltip = useAnalyticsTooltip({ bar: barData.tooltip, line: areaData.tooltip });

  const labels = [
    ['Contact with', 'candidate'],
    'CV screening',
    ['Technical', 'interview'],
    ['Management', 'interview'],
    ['Management', 'approval'],
    'Offer',
    'Onboarding',
  ];

  const data = {
    labels,
    datasets: [
      {
        type: 'bar' as const,
        label: 'Step time',
        data: barData.data,
        backgroundColor: '#FC4C02',
        barPercentage: 0.4,
        borderRadius: {
          topLeft: 4,
          topRight: 4,
        },
      },
      {
        type: 'line' as const,
        label: 'Total time',
        data: areaData.data,
        borderWidth: 1,
        backgroundColor: '#F67D37',
        borderColor: '#F67D37',
        fill: {
          value: 0,
          above: '#FFF1E5',
        },
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
        external: tooltip,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          color: '#D5D5D8',
        },
        ticks: {
          color: '#FC4C02',
          font: {
            size: 14,
          },
          padding: 24,
        },
      },
      y: {
        ticks: {
          color: '#757575',
          font: {
            size: 14,
          },
          padding: 24,
        },
        grid: {
          borderDash: [7, 10],
          drawBorder: false,
          color: (context: { index: number }) => {
            if (!context.index) return 'transparent';
            return '#D5D5D8';
          },
        },
      },
    },
  };

  return (
    <div className="graphic">
      <Bar className="mixed" data={data as ChartData<'bar'>} options={options as ChartOptions<'bar'>} />
    </div>
  );
};
